














































































import { computed, defineComponent, ref } from '@vue/composition-api'
import { useGetters } from '../../store/useGetters'
import { useActions } from '../../store/useActions'
import colorScheme from '../../colorScheme'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faCaretUp } from '@fortawesome/free-solid-svg-icons'

export default defineComponent({
  name: 'TagsCategory',
  components: { FontAwesomeIcon },
  props: {
    color: {
      type: String,
      default: 'blue',
      required: false
    },
    open: {
      type: Boolean
    },
    title: {
      type: String
    },
    subtopicsChecked: {
      type: Number,
      required: true
    },
    active: {
      type: Boolean,
      default: true,
      required: true
    }
  },
  setup() {
    const subcategoryName = ref('')
    const isAddNewSubtopicVisible = ref(false)

    const getters = useGetters({
      topics: 'tagsPicker/topicsCategories',
      active: 'tagsPicker/isActive'
    })
    const actions = useActions({
      addUserDefinedCategory: 'tagsPicker/addUserDefinedCategory'
    })

    function addUserDefinedSubcategory() {
      if (subcategoryName.value !== '') {
        actions.addUserDefinedCategory(subcategoryName.value)
        isAddNewSubtopicVisible.value = false
      }
    }

    const isInputVisible = computed(() => {
      if (getters.active.value === false) {
        isAddNewSubtopicVisible.value = false
      }
      return isAddNewSubtopicVisible.value && getters.active.value
    })

    function showInputUserDefinedSubcategory() {
      isAddNewSubtopicVisible.value = !isAddNewSubtopicVisible.value
      subcategoryName.value = ''
    }

    function focusOnInputRemoveSelection(e) {
      e.target.focus()
    }
    return {
      focusOnInputRemoveSelection,
      isInputVisible,
      showInputUserDefinedSubcategory,
      addUserDefinedSubcategory,
      subcategoryName,
      colorScheme,
      isAddNewSubtopicVisible,
      topics: getters.topics,
      iCaretUp: faCaretUp
    }
  }
})
